import { render, staticRenderFns } from "./TutoratCreate.vue?vue&type=template&id=05ae3af6&"
import script from "./TutoratCreate.vue?vue&type=script&lang=js&"
export * from "./TutoratCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports